module.exports = __webpack_public_path__ + "media/1_3-30.6094a7b5.mp3";